export function isIOS() {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return /iphone|ipod|ipad/.test(userAgent);
}
